import { useState, type FormEvent } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Message } from "primereact/message";
import { Password } from "primereact/password";
import { useAuth } from "../../contexts/AuthContext";

export function LoginPage() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const { login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const submit = async (event: FormEvent) => {
        event.preventDefault();
        try {
            setLoading(true);
            setError("");
            await login(username, password);
            navigate(location.state?.from?.pathname || "/", { replace: true });
        } catch {
            setError("Usuário ou senha inválidos. Confira os dados e tente novamente.");
        } finally {
            setLoading(false);
        }
    };
    return (
        <main className="login-page">
            <section className="login-intro">
                <div className="login-brand">
                    <img src="/logos/coopervass.png" alt="Coopervass" className="brand-logo brand-logo--login" />
                </div>
                <div className="login-message">
                    <span className="eyebrow light">Operação conectada</span>
                    <h1>
                        O estoque certo,
                        <br />
                        no lugar certo.
                    </h1>
                    <p>Receba, separe e movimente matérias-primas com segurança pelo tablet ou celular.</p>
                    <div className="login-features">
                        <span>
                            <i className="pi pi-check-circle" /> FEFO automático
                        </span>
                        <span>
                            <i className="pi pi-qrcode" /> Conferência por QR
                        </span>
                        <span>
                            <i className="pi pi-history" /> Rastreabilidade total
                        </span>
                    </div>
                </div>
            </section>
            <section className="login-panel">
                <form className="login-card" onSubmit={submit}>
                    <div className="mobile-login-brand">
                        <img src="/logos/coopervass.png" alt="Coopervass" className="brand-logo brand-logo--mobile" />
                    </div>
                    <span className="eyebrow">Acesso seguro</span>
                    <h2>Bem-vindo de volta</h2>
                    <p>Entre com suas credenciais para iniciar a operação.</p>
                    {error ? <Message severity="error" text={error} className="login-error" /> : null}
                    <label>
                        <span>Usuário</span>
                        <InputText
                            value={username}
                            autoCapitalize="none"
                            autoComplete="username"
                            onChange={(event) => setUsername(event.target.value)}
                            placeholder="Digite seu usuário"
                            className="w-full"
                        />
                    </label>
                    <label>
                        <span>Senha</span>
                        <Password
                            value={password}
                            onChange={(event) => setPassword(event.target.value)}
                            feedback={false}
                            toggleMask
                            autoComplete="current-password"
                            placeholder="Digite sua senha"
                            className="w-full"
                            inputClassName="w-full"
                        />
                    </label>
                    <Button
                        type="submit"
                        label="Entrar no sistema"
                        icon="pi pi-arrow-right"
                        iconPos="right"
                        loading={loading}
                        disabled={!username || !password}
                    />
                    <small className="login-help">
                        <i className="pi pi-lock" /> Suas credenciais são transmitidas de forma segura.
                    </small>
                </form>
            </section>
        </main>
    );
}
